import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.BUN_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.BUN_PUBLIC_SUPABASE_PUBLISHABLE_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
